import PropTypes from "prop-types";

import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Icon from "@mui/material/Icon";

import MDBox from "components/MDBox";

import {
  collapseItem,
  collapseIconBox,
  collapseIcon,
  collapseText,
} from "ui/Sidenav/styles/sidenavCollapse";

import { useMaterialUIController } from "context";
import { makeStyles } from "@mui/styles";
import { Divider, List } from "@mui/material";

const useStyles = makeStyles(() => ({
  listItem: {
    "&:hover": {
      backgroundColor: "#e0e0e0",
    },

    "&:selected ": {
      backgroundColor: "red",
    },
    marginLeft: 15,
  },
  listText: {
    color: "black",
    paddingRight: 15,
  },
}));
function SidenavCollapse({ icon, name, active, type, ...rest }) {
  const [controller] = useMaterialUIController();
  const { miniSidenav, transparentSidenav, whiteSidenav, darkMode, sidenavColor } = controller;
  const classes = useStyles();
  return (
    <ListItem component="li">
      {type === "nested" ? (
        <div
          style={{
            backgroundColor: `${active ? "#e0e0e0" : "white"}`,
            marginLeft: 30,
            marginRight: 20,
            width: "100%",
          }}
        >
          <List>
            <ListItem className={classes.listItem}>
              <ListItemText
                primary={name}
                className={classes.listText}
                primaryTypographyProps={{ fontSize: "14px", color: "black" }}
                sx={{
                  whiteSpace: "normal",
                  wordBreak: "break-word",
                }}
              />
            </ListItem>
          </List>
          <Divider />
        </div>
      ) : (
        <MDBox
          {...rest}
          sx={(theme) =>
            collapseItem(theme, {
              active,
              transparentSidenav,
              whiteSidenav,
              darkMode,
              sidenavColor,
            })
          }
        >
          <ListItemIcon
            sx={(theme) =>
              collapseIconBox(theme, { transparentSidenav, whiteSidenav, darkMode, active })
            }
          >
            {typeof icon === "string" ? (
              <Icon sx={(theme) => collapseIcon(theme, { active })}>{icon}</Icon>
            ) : (
              icon
            )}
          </ListItemIcon>

          <ListItemText
            primary={name}
            sx={(theme) =>
              collapseText(theme, {
                miniSidenav,
                transparentSidenav,
                whiteSidenav,
                active,
              })
            }
          />
        </MDBox>
      )}
    </ListItem>
  );
}

SidenavCollapse.defaultProps = {
  active: false,
  type: "",
};

SidenavCollapse.propTypes = {
  icon: PropTypes.node.isRequired,
  name: PropTypes.string.isRequired,
  active: PropTypes.bool,
  type: PropTypes.string,
};

export default SidenavCollapse;
